import React from "react";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";

// dealerView: bayi tarafı — fiyat, kota katsayısı ve maksimum gösterilmez.
const ProductCard = ({ product, quotaData, onEdit, onDelete, isLoading, dealerView = false }) => {
  const totalQuota = quotaData.reduce((acc, item) => {
    if (item.name === product.productName) return parseInt(item.quota) + parseInt(product.quota);
    return acc;
  }, 0);

  return (
    <div className="bg-white rounded-xl border border-gray-200 hover:border-blue-200 hover:shadow-md transition-all duration-200 overflow-hidden group">
      {/* Header - kompakt */}
      <div className="flex items-center justify-between px-3.5 py-2.5 border-b border-gray-100 bg-gray-50">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center">
            <span className="text-indigo-600 font-bold text-xs">
              {product.productName?.charAt(0)}
            </span>
          </div>
          <div>
            <h3 className="text-sm font-bold text-gray-900 leading-tight">{product.productName}</h3>
            <span className="text-[11px] text-gray-400">Ürün Konfigürasyonu</span>
          </div>
        </div>
        <div className="flex items-center gap-0.5">
          {onEdit && (
            <button
              onClick={() => onEdit(product)}
              disabled={isLoading}
              className="p-1.5 text-gray-300 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all opacity-0 group-hover:opacity-100 disabled:opacity-50"
              title="Düzenle"
            >
              <FaPencilAlt className="w-3 h-3" />
            </button>
          )}
          {onDelete && (
            <button
              onClick={() => onDelete(product)}
              disabled={isLoading}
              className="p-1.5 text-gray-300 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all opacity-0 group-hover:opacity-100 disabled:opacity-50"
              title="Ürünü Sil (sadece sistem yöneticisi)"
            >
              <FaTrashAlt className="w-3 h-3" />
            </button>
          )}
        </div>
      </div>

      <div className="px-3.5 py-3 space-y-3">
        {/* Kota özeti */}
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-blue-50 rounded-lg px-2.5 py-2 border border-blue-100">
            <span className="text-[11px] font-semibold text-blue-500 uppercase tracking-wide block mb-0.5">Toplam Kota</span>
            <span className="text-base font-bold text-blue-700">{totalQuota?.toLocaleString("tr-TR")}</span>
          </div>
          <div className="bg-amber-50 rounded-lg px-2.5 py-2 border border-amber-100">
            <span className="text-[11px] font-semibold text-amber-500 uppercase tracking-wide block mb-0.5">Dağıtılmamış</span>
            <span className="text-base font-bold text-amber-700">{product.quota?.toLocaleString("tr-TR")}</span>
          </div>
        </div>

        {/* Ayarlar listesi - kompakt */}
        <div className="space-y-0">
          {!dealerView && <Row label="Ürün Fiyatı" value={`₺${product.productPrice}`} valueColor="text-emerald-600" />}
          {!dealerView && <Row label="Kota Katsayısı" value={product.quotaCoefficient} />}
          <Row label="Sipariş Aralığı" value={`${product.orderFrequencyDays} gün`} valueColor="text-purple-600" />
          <Row label="Aylık Hedef" value={product.goalConsumentMonthly?.toLocaleString("tr-TR")} />
        </div>

        {/* Kota seviyeleri */}
        <div className={`grid ${dealerView ? "grid-cols-1" : "grid-cols-2"} gap-2`}>
          <div className="bg-gray-50 rounded-lg px-2.5 py-2 border border-gray-100 text-center">
            <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide block mb-0.5">Uyarı</span>
            <span className="text-sm font-bold text-amber-600">{product.quotaWarning?.toLocaleString("tr-TR")}</span>
          </div>
          {!dealerView && (
            <div className="bg-gray-50 rounded-lg px-2.5 py-2 border border-gray-100 text-center">
              <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide block mb-0.5">Maximum</span>
              <span className="text-sm font-bold text-gray-800">{product.quotaMax?.toLocaleString("tr-TR")}</span>
            </div>
          )}
        </div>

        {/* Senkronizasyon */}
        <div className="border-t border-gray-100 pt-2.5 space-y-0">
          <Row label="Senk. Seviyesi" value={product.syncLevel} valueColor="text-indigo-600" />
          <div className="flex items-center justify-between py-1.5">
            <span className="text-[11px] text-gray-500">Kota Alma</span>
            <span className={`inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full ${
              product.quotaDistribution ? "bg-emerald-100 text-emerald-700" : "bg-red-50 text-red-600"
            }`}>
              <span className={`w-1.5 h-1.5 rounded-full ${product.quotaDistribution ? "bg-emerald-500" : "bg-red-400"}`} />
              {product.quotaDistribution ? "Açık" : "Kapalı"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const Row = ({ label, value, valueColor = "text-gray-800" }) => (
  <div className="flex items-center justify-between py-1.5">
    <span className="text-[11px] text-gray-500">{label}</span>
    <span className={`text-xs font-bold ${valueColor}`}>{value}</span>
  </div>
);

export default ProductCard;
